import { getImageUrlFromName } from '../../../util'
import info from '../../../assets/images/icons/info.svg'

const SourceLayout = ({ layout, value }) => {
  return (
    <>
      {layout.value && (
        <div
          style={{
            display: 'flex',
            padding: '0 20px 0 20px',
            alignItems: 'center',
            background: layout.color ? `#${layout.color}` : '',
          }}
        >
          <img src={info} alt="" style={{ width: '20px', height: 'auto' }} />
          <p
            style={{
              margin: '0px',
              textAlign: 'left',
              // listStyle: 'none',
              // fontWeight: 700,
              // fontSize: '20px',

              lineHeight: '140%',
              color: 'var(--gray60)',
            }}
            className="body4"
          >
            {layout.display_name}
          </p>
          <img
            src={layout.name}
            alt=""
            style={{ width: '20px', height: 'auto' }}
          />
        </div>
      )}
    </>
  )
}

export default SourceLayout
